import {HeaderTitle, Icon} from '@/components/atoms'
import {PageHeader} from '@/components/molecules'
import BulkModifiersList from '@/pages/BulkModifiersList'
import {Header} from '@/utils/constants/header'

const BulkModifiersHome = () => {

  return (
    <div className="bulkModifiersContainer flex flex-col">
      <PageHeader title="Bulk Point Modifiers" />
      <div className="targetCardComponent mb-5"></div>
      <div className="relative" style={{backgroundColor: '#1D1D1D'}}>
        <HeaderTitle
          headingLevel={Header.SectionTitle}
          title="Bulk Point Modifiers List"
          className="bulkModifiersDataTableHeading  pl-4 pr-4"
        />
        <span className="bulkModifiersSettingsIcon absolute h-8 w-8 rounded p-2">
          <Icon icon="settings" isDark={true} size="small" className="h-4 w-4" />
        </span>
        <BulkModifiersList />
      </div>
    </div>
  )
}

export default BulkModifiersHome
